import { translateRevenueType } from '@/lib/translations';

/**
 * Rótulo da legenda da "Linha do Tempo de Receitas por Tipo".
 *
 * Mora fora do `ReportsPage`, e não inline no `formatter` da `<Legend>`, porque
 * definir um componente dentro do componente pai o recria a cada render e faz o
 * React remontar a subárvore em vez de atualizá-la (typescript:S6478).
 *
 * Em arquivo próprio, e não exportado do `ReportsPage`, porque um módulo que
 * exporta um componente e mais alguma coisa perde o fast refresh
 * (react-refresh/only-export-components) — mesma razão que levou a 3792 a pôr
 * sua regra em `lib/expense-in-revenue.ts`.
 *
 * O texto é `text-foreground` de propósito: a cor da série identifica o dado no
 * marcador ao lado, nunca no rótulo. Pintar o texto com ela derrubava as quatro
 * séries abaixo de 4.5:1 no tema claro — o âmbar chegava a 2.13:1. As decisões
 * da paleta estão documentadas em `REVENUE_TIMELINE_TYPE_COLORS`, no ReportsPage.
 *
 * O `Formatter` do recharts declara `value: any`. Aqui o parâmetro é estreitado
 * para o que a legenda de fato recebe — o `name` de cada <Bar>. `unknown` não
 * serve: `String()` sobre um tipo que pode ser objeto rende '[object Object]'
 * em silêncio (typescript:S6551).
 */
export const renderRevenueTimelineLegendLabel = (value: string | number | undefined) => (
  <span className="text-foreground">{translateRevenueType(String(value || ''))}</span>
);
